<osapp-selector displayMode="tags" [options]="selectOptions" (selectionChanged)="selectionChanged($event)"
	scrollWrapper="true">
</osapp-selector>